module.exports = __webpack_public_path__ + "img/miscellaneous-ico.506bd7bb.svg";